// extracted by mini-css-extract-plugin
module.exports = {"content":"KR","notSelected":"LR"};